export var UserReportReasonEnum = /*#__PURE__*/ function(UserReportReasonEnum) {
    UserReportReasonEnum[UserReportReasonEnum["CheatingWithAnotherPlayer"] = 1] = "CheatingWithAnotherPlayer";
    UserReportReasonEnum[UserReportReasonEnum["AbusingChat"] = 2] = "AbusingChat";
    UserReportReasonEnum[UserReportReasonEnum["InappropriateUsername"] = 3] = "InappropriateUsername";
    UserReportReasonEnum[UserReportReasonEnum["WastingTime"] = 4] = "WastingTime";
    UserReportReasonEnum[UserReportReasonEnum["Griefing"] = 5] = "Griefing";
    UserReportReasonEnum[UserReportReasonEnum["ThrowingTheGame"] = 6] = "ThrowingTheGame";
    return UserReportReasonEnum;
}({});
export var PieceTypes = /*#__PURE__*/ function(PieceTypes) {
    PieceTypes[PieceTypes["City"] = 0] = "City";
    PieceTypes[PieceTypes["Settlement"] = 1] = "Settlement";
    PieceTypes[PieceTypes["Road"] = 2] = "Road";
    PieceTypes[PieceTypes["DevelopmentCard"] = 3] = "DevelopmentCard";
    PieceTypes[PieceTypes["Ship"] = 4] = "Ship";
    PieceTypes[PieceTypes["CityWall"] = 5] = "CityWall";
    PieceTypes[PieceTypes["Knight"] = 6] = "Knight";
    return PieceTypes;
}({});
// Dec 5, 2020. This is a placeholder until the room design is done
export var TemporaryModeSettingEnum = /*#__PURE__*/ function(TemporaryModeSettingEnum) {
    TemporaryModeSettingEnum[TemporaryModeSettingEnum["TutorialClassic"] = 0] = "TutorialClassic";
    TemporaryModeSettingEnum[TemporaryModeSettingEnum["Classic"] = 1] = "Classic";
    TemporaryModeSettingEnum[TemporaryModeSettingEnum["Seafarers"] = 2] = "Seafarers";
    TemporaryModeSettingEnum[TemporaryModeSettingEnum["CitiesAndKnights"] = 3] = "CitiesAndKnights";
    TemporaryModeSettingEnum[TemporaryModeSettingEnum["CitiesAndKnightsSeafarers"] = 4] = "CitiesAndKnightsSeafarers";
    TemporaryModeSettingEnum[TemporaryModeSettingEnum["Inactive"] = 5] = "Inactive";
    TemporaryModeSettingEnum[TemporaryModeSettingEnum["ServerStressTest"] = 6] = "ServerStressTest";
    return TemporaryModeSettingEnum;
}({});
export var CurrentStateControllerTypeEnum = /*#__PURE__*/ function(CurrentStateControllerTypeEnum) {
    CurrentStateControllerTypeEnum[CurrentStateControllerTypeEnum["Default"] = 0] = "Default";
    CurrentStateControllerTypeEnum[CurrentStateControllerTypeEnum["ColonistRush"] = 1] = "ColonistRush";
    return CurrentStateControllerTypeEnum;
}({});
